export type GradStudent = {
  image: string;
  name: string;
  level: "doctorado" | "maestria" | "licenciatura";
  roleKey: string;
  descriptionKey: string;
  thesisTitleKey?: string;
  thesisDescKey?: string;
  graduationYear?: string;
  specialtyKeys?: string[];
  email?: string;
  linkedin?: string;
};

export const gradStudents: GradStudent[] = [
  // --- DOCTORADO ---
  {
    image: "./img/ourTeam/posgrado/Yumil.jpg",
    name: "Mtro. Yumil Aj Itzat Rueda Flores-Trejo",
    level: "doctorado",
    roleKey: "student_doc_role",
    descriptionKey: "student_doc1_desc",
    thesisTitleKey: "student_doc1_thesis_title",
    thesisDescKey: "student_doc1_thesis_desc",
    graduationYear: "2028",
    specialtyKeys: ["spec_ia", "spec_iot", "spec_embebidos"],
    email: "A13004497@correo.uady.mx",
    linkedin: "https://www.linkedin.com/in/yumil-aj-itzat-rueda-flores-trejo-916bb4145/",
  },
  {
    image: "./img/ourTeam/posgrado/Gedao.jpeg",
    name: "Mtro. Gedeão Santos Nunes de Oliveira",
    level: "doctorado",
    roleKey: "student_doc_role",
    descriptionKey: "student_doc2_desc",
    thesisTitleKey: "student_doc2_thesis_title",
    thesisDescKey: "student_doc2_thesis_desc",
    graduationYear: "2029",
    specialtyKeys: ["spec_vlsi", "spec_iot", "spec_embebidos", "spec_seguridad"],
    linkedin: "https://www.linkedin.com/in/gedeaosanntos/",
  },
  {
    image: "./img/ourTeam/posgrado/Andy.png",
    name: "Mtra. Andrea del Alba Garma Fernández",
    level: "doctorado",
    roleKey: "student_doc_role",
    descriptionKey: "student_doc3_desc",
    thesisTitleKey: "student_doc3_thesis_title",
    thesisDescKey: "student_doc3_thesis_desc",
    graduationYear: "2029",
    specialtyKeys: ["spec_manufactura_aditiva", "spec_opt_estructural", "spec_aeroespacial"],
    email: "andreagarmafernandez@gmail.com",
    linkedin: "",
  },
  {
    image: "./img/ourTeam/posgrado/Isaac.jpeg",
    name: "Mtro. Isaac Guibaldo Villajuana Hernández",
    level: "doctorado",
    roleKey: "student_doc_role",
    descriptionKey: "student_doc4_desc",
    thesisTitleKey: "student_doc4_thesis_title",
    thesisDescKey: "student_doc4_thesis_desc",
    graduationYear: "2030",
    specialtyKeys: ["spec_ia", "spec_edge", "spec_embebidos", "spec_shm", "spec_redes", "spec_aiot"],
    linkedin: "",
  },
  {
    image: "./img/ourTeam/Fabian.jpeg",
    name: "Mtro. Fabián Aguirre Fonseca",
    level: "doctorado",
    roleKey: "student_doc_role",
    descriptionKey: "student_doc5_desc",
    thesisTitleKey: "student_doc5_thesis_title",
    thesisDescKey: "student_doc5_thesis_desc",
    graduationYear: "2028",
    specialtyKeys: ["spec_rfeh", "spec_redes", "spec_bajopotencia", "spec_control"],
    linkedin: "",
  },
  {
    image: "./img/ourTeam/posgrado/JorgeFlores.png",
    name: "Mtro. Jorge David Flores Tun",
    level: "doctorado",
    roleKey: "student_doc_role",
    descriptionKey: "student_doc6_desc",
    thesisTitleKey: "student_doc6_thesis_title",
    thesisDescKey: "student_doc6_thesis_desc",
    graduationYear: "2030",
    specialtyKeys: ["spec_vlsi", "spec_energia"],
    email: "A15003780@alumnos.uady.mx",
  },

  // --- MAESTRÍA ---
  
  {
    image: "./img/ourTeam/posgrado/Marco.png",
    name: "Ing. Marco Alejandro González Barbudo",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_mae2_desc",
    thesisTitleKey: "student_mae2_thesis_title",
    thesisDescKey: "student_mae2_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_vlsi", "spec_robotica", "spec_sensores", "spec_embebidos"],
  },
  {
    image: "./img/ourTeam/posgrado/PedroFerrer.jpeg",
    name: "Ing. Pedro Manuel Ferrer Pérez",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_mae3_desc",
    thesisTitleKey: "student_mae3_thesis_title",
    thesisDescKey: "student_mae3_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_ia", "spec_embebidos", "spec_biomedica", "spec_sensores"],
  },
  {
    image: "./img/ourTeam/posgrado/Mike.png",
    name: "Ing. Miguel Angel Landero Cruz",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_mae4_desc",
    thesisTitleKey: "student_mae4_thesis_title",
    thesisDescKey: "student_mae4_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_ia", "spec_embebidos", "spec_biomedica", "spec_sensores"],
  },
  {
    image: "./img/ourTeam/posgrado/Edwin.jpeg",
    name: "Ing. Edwin Cahuich",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_mae5_desc",
    thesisTitleKey: "student_mae5_thesis_title",
    thesisDescKey: "student_mae5_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_telecom", "spec_embebidos", "spec_bajopotencia", "spec_sensores"],
  },
   {
    image: "./img/ourTeam/Felipe.jpg",
    name: "Ing. Felipe Iván Sierra Borunda",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_lic1_desc",
    thesisTitleKey: "student_lic1_thesis_title",
    thesisDescKey: "student_lic1_thesis_desc",
    graduationYear: "2028",
    specialtyKeys: ["spec_ia", "spec_embebidos", "spec_biomedica", "spec_sensores"],
    linkedin: "https://www.linkedin.com/in/felipe-ivan-sierra-borunda-a92902400",
  },
  {
    image: "./img/ourTeam/Sebastian.jpg",
    name: "Ing. Juan Sebastián Patrón Rodríguez",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_lic4_desc",
    thesisTitleKey: "student_lic4_thesis_title",
    thesisDescKey: "student_lic4_thesis_desc",
    graduationYear: "2028",
    specialtyKeys: ["spec_sensores", "spec_embebidos", "spec_robotica"],
    linkedin: "https://www.linkedin.com/in/sebastián-patrón-rodríguez-3830443ab",
  },
  {
    image: "./img/ourTeam/JorgePat.jpeg",
    name: "Ing. Jorge Pat Camal",
    level: "maestria",
    roleKey: "student_mae_role",
    descriptionKey: "student_lic6_desc",
    thesisTitleKey: "student_lic6_thesis_title",
    thesisDescKey: "student_lic6_thesis_desc",
    graduationYear: "2028",
    specialtyKeys: ["spec_sensores", "spec_materiales", "spec_embebidos"],
  },

  // --- LICENCIATURA ---
 
  {
    image: "./img/ourTeam/Magana.jpeg",
    name: "Luis Enrique Magaña Vallejos",
    level: "licenciatura",
    roleKey: "student_lic_role",
    descriptionKey: "student_lic2_desc",
    thesisTitleKey: "student_lic2_thesis_title",
    thesisDescKey: "student_lic2_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_fpga", "spec_embebidos", "spec_iot"],
  },
  {
    image: "./img/ourTeam/Luis.jpeg",
    name: "Ing. Luis Ángel Navarro Flores",
    level: "licenciatura",
    roleKey: "student_lic_role",
    descriptionKey: "student_lic3_desc",
    thesisTitleKey: "student_lic3_thesis_title",
    thesisDescKey: "student_lic3_thesis_desc",
    graduationYear: "2025",
    specialtyKeys: ["spec_fpga", "spec_vlsi", "spec_ia", "spec_sensores"],
    linkedin: "https://www.linkedin.com/in/luis-navarro-flores-2242283a2",
  },
  
  {
    image: "./img/ourTeam/Francisco.jpeg",
    name: "Francisco Manuel Bacab Ramos",
    level: "licenciatura",
    roleKey: "student_lic_role",
    descriptionKey: "student_lic5_desc",
    thesisTitleKey: "student_lic5_thesis_title",
    thesisDescKey: "student_lic5_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_ia", "spec_fpga", "spec_embebidos"],
  },
  
  {
    image: "./img/ourTeam/Tony.jpeg",
    name: "Ing. José Antonio Pech Vázquez",
    level: "licenciatura",
    roleKey: "student_lic_role",
    descriptionKey: "student_lic7_desc",
    thesisTitleKey: "student_lic7_thesis_title",
    thesisDescKey: "student_lic7_thesis_desc",
    graduationYear: "2025",
    specialtyKeys: ["spec_iot", "spec_embebidos", "spec_energia"],
    email: "A17001200@alumnos.uady.mx",
    linkedin: "https://www.linkedin.com/in/jos%C3%A9-antonio-pech-v%C3%A1zquez-26979324a/",
  },
  {
    image: "./img/ourTeam/PedroCasanova.png",
    name: "Pedro Antonio Casanova Martin",
    level: "licenciatura",
    roleKey: "student_lic_role",
    descriptionKey: "student_lic8_desc",
    thesisTitleKey: "student_lic8_thesis_title",
    thesisDescKey: "student_lic8_thesis_desc",
    graduationYear: "2026",
    specialtyKeys: ["spec_ia", "spec_fpga", "spec_embebidos"],
    email: "Pedro.Casanova1@outlook.ocm",
  },
];